import { Checkbox, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { ARIA_LABEL } from "designSystem/wai-aria";

export default () => {
	const [checked, setChecked] = useState(false);

	function onChange(event: object, value: boolean) {
		setChecked(value);
	};

	return (
		<CssColumnGrid columns={5}>
			<Text semiBold text="enabled" />
			<Text semiBold text="invalid" />
			<Text semiBold text="indeterminate" />
			<Text semiBold text="disabled" />
			<Text semiBold text="disabled + checked" />
			<Checkbox
				checked={checked}
				inputProps={{ [ARIA_LABEL]: "checkbox enabled showcase" }}
				onChange={onChange}
			/>
			<Checkbox
				checked={checked}
				inputProps={{ [ARIA_LABEL]: "checkbox invalid showcase" }}
				invalid
				onChange={onChange}
			/>
			<Checkbox
				checked={checked}
				indeterminate
				inputProps={{ [ARIA_LABEL]: "checkbox indeterminate showcase" }}
				onChange={onChange}
			/>
			<Checkbox
				checked={false}
				disabled
				inputProps={{ [ARIA_LABEL]: "checkbox disabled showcase" }}
			/>
			<Checkbox
				checked
				disabled
				inputProps={{ [ARIA_LABEL]: "checkbox disabled + checked showcase" }}
			/>
		</CssColumnGrid>
	);
};